<template>
  <div>
    <CRow>
      <CCol>
        <CAlert show color="info" v-if="habilitaClientes()">
          Ao aplicar regras de bloqueio de segmento, elas passarão a ser aplicadas em todos os clientes, exceto nos
          clientes liberados abaixo.
        </CAlert>
        <CAlert show color="warning" v-if="!habilitaClientes()">
          Caso os parâmetros <b>"Validar grupo de segmento de venda."</b> estiverem inativos, os clientes não estarão visíveis aqui.
        </CAlert>
      </CCol>
    </CRow>

    <template v-if="habilitaClientes()">
      <CRow class="align-items-center">
        <div class="col-sm-7">
          <input
            type="text"
            class="form-control m-2"
            placeholder="Buscar por ID, nome ou razão social"
            v-model="termoBusca"
            @input="debounceBuscar"
          />
        </div>
        <div class="col-sm-5 text-right">
          <CButton color="danger" class="m-2" @click="unCheckAll(items, colaborador.id)" :disabled="items.length <= 0">
            Bloquear Exibidos
          </CButton>
          <CButton color="success" class="m-2" @click="checkAll(items, colaborador.id)" :disabled="items.length <= 0">
            Liberar Exibidos
          </CButton>
        </div>
      </CRow>

      <CDataTable
        :items="items"
        :fields="fields"
        hover
        border
        :noItemsView="{noItems: 'Nenhum cliente encontrado'}"
      >
        <template #status="{item}">
          <td>
            <label class="c-switch c-switch-sm c-switch-3d c-switch-success">
              <input v-if="testItemChecked(item.id)" type="checkbox" class="c-switch-input" name="checkCliente" :checked="testItemChecked(item.id)"
                @change="upInsertClienteExcecao(colaborador.id, item.id, 0)">
              <input v-else-if="!testItemChecked(item.id)" type="checkbox" class="c-switch-input" name="checkCliente" :checked="testItemChecked(item.id)"
                @change="upInsertClienteExcecao(colaborador.id, item.id, 1)">
              <span class="c-switch-slider"></span>
            </label>
          </td>
        </template>
      </CDataTable>

      <div class="d-flex justify-content-center p-2" v-if="paginator && paginator.last_page > 1">
        <pagination
          :data="paginator"
          :limit="2"
          @pagination-change-page="onTrocarPagina"
        />
      </div>
    </template>
  </div>
</template>

<script>
const fields = [
  {
    key: 'status',
    sorter: false,
    filter: false
  },
  {
    key: 'id',
    label: 'ID',
    sorter: false,
    filter: false
  },
  {
    key: 'fant',
    label: 'Nome',
    sorter: false,
    filter: false
  },
]

export default {
  name: 'TableClientesSegmentoVenda',
  props: [
    'items',
    'colaborador',
    'paginator',
    'termoInicial',
    'upInsertClienteExcecao',
    'insertAllClientes',
    'deleteAllClientes',
    'onBuscar',
    'onTrocarPagina',
    'parametros'
  ],
  data () {
    return {
      fields,
      termoBusca: this.termoInicial || '',
      debounce: null,
    }
  },
  methods: {
    debounceBuscar() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.onBuscar(this.termoBusca);
      }, 500);
    },
    checkAll(itensForChecked, colaboradorId){
      this.insertAllClientes(itensForChecked, colaboradorId);
    },
    unCheckAll(itensForChecked, colaboradorId){
      this.deleteAllClientes(itensForChecked, colaboradorId);
    },
    testItemChecked(itemId){
      var test = false;
      test = this.items.find(clientes =>
                                clientes.id == itemId
                                && clientes.status == 1);
      if(test != null){
        return true;
      }
      return false;
    },
    habilitaClientes() {
      const CALLCENTER = this.parametros.CALLCENTER_VALIDA_SEGMENTO_VENDA.padrao;
      const FORCA      = this.parametros.FORCA_VENDAS_VALIDA_SEGMENTO_VENDA.padrao;

      if (CALLCENTER == 1 || FORCA == 1) {
        return true;
      }

      return false;
    }
  }
}
</script>
